import React from "react";

const Grid = ({ data }) => {
    if (!data || !data.grid || data.grid.length === 0) {
        return <div>No data available</div>;
    }

    return (
        <div className="flex flex-col gap-2">
            <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
                {data.grid.map((grid, index) => (
                    <div key={index} className="flex flex-col p-5 lg:justify-between md:justify-normal justify-between lg:gap-0 md:gap-20 gap-10 rounded-3xl lg:aspect-square md:aspect-auto aspect-video bg-no-repeat bg-cover" 
                        style={{ backgroundColor: grid.bg_color, backgroundImage: grid.bg_img ? `url("${grid.bg_img}")` : 'none' }}
                    >
                        <div className="flex flex-col gap-4">
                            <span className="font-medium lg:text-[18px] md:text-[24px] text-[24px] leading-tight" 
                                style={{ color: grid.title_color }}
                            >
                                {grid.title}
                            </span>
                            <span className="font-medium lg:text-[14px] md:text-[18px] text-[16px] leading-tight" 
                                style={{ color: grid.desc_color }}
                            >
                                {grid.desc}
                            </span>
                        </div>
                        <div className="flex justify-center ml-auto rounded-full items-center h-12 w-12" 
                            style={{ backgroundColor: grid.bg_icon_color }}
                        >
                            {grid.icon && <img src={grid.icon} alt="" />}
                        </div>
                    </div>
                                    ))}
                                    </div>
                                </div>
                            );
                        };
                        
                        export default Grid;